import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { Modal } from '../../Modal';
import RehireDispatcherModal from '../RehireDispatcherModal/RehireDispatcherModal';

interface PreviewDriverToRehireProps {
  data: any;
}

const PreviewDriverToRehire: React.FC<PreviewDriverToRehireProps> = ({
  data,
}) => {
  const [showRehireDriverModal, setShowRehireDriverModal] =
    React.useState(false);
  const { sliderIndex, setSliderIndexPos } = useContext(
    TranslatingContainerContext,
  )!;

  const onSubmit = () => {
    setSliderIndexPos(1);
  };

  return (
    <Container className={sliderIndex > 0 ? 'inactive' : ''}>
      <Flex>
        <BioArea>
          <Img
            src={
              data?.profilePicture ??
              '/static/img/profilePlaceholderLargePlain.png'
            }
          />
          <NameLabel>
            {data?.firstName} {data?.lastName}
          </NameLabel>
        </BioArea>

        <GreyArea>
          <Row>
            <div>First name</div>
            <div>{data?.firstName || 'N/A'}</div>
          </Row>
          <Row>
            <div>Last Name</div>
            <div>{data?.lastName || 'N/A'}</div>
          </Row>
          <Row>
            <div>Gender</div>
            <div>{data?.gender || 'N/A'}</div>
          </Row>
        </GreyArea>

        <ButtonArea>
          <FormSubmitButton
            className='clear fill border-blue color-blue'
            onClick={() => {
              setShowRehireDriverModal(true);
              // modalContext?.setShowModal(false);
            }}
            btnType='button'
          >
            Update Information
          </FormSubmitButton>
          <FormSubmitButton
            btnType='button'
            onClick={onSubmit}
            className='fill'
          >
            Continue
          </FormSubmitButton>
        </ButtonArea>
      </Flex>

      <Modal
        showModal={showRehireDriverModal}
        setShowModal={setShowRehireDriverModal}
      >
        <RehireDispatcherModal data={{ driverId: data?.id }} />
      </Modal>
    </Container>
  );
};

export default PreviewDriverToRehire;

const Container = styled.div`
  display: flex;
  width: 100%;

  &.inactive > * {
    display: none;
  }
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const GreyArea = styled.div`
  width: 100%;
  background-color: #fafafa;
  color: ${({ theme }) => theme.palette.grayTextColor};
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const BioArea = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 6px;
`;

const Img = styled.img`
  width: 67px;
  height: 67px;
  border-radius: 8px;
  overflow: hidden;
`;

const NameLabel = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 140px;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;

  & > div:last-of-type {
    font-weight: 600;
    color: #2f3644;
  }

  @media (max-width: 884px) {
    gap: 16px;
  }
`;
